import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Pricing() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-239">
      <div className="max-w-7xl mx-auto" data-id="element-240">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-241">
          INVESTMENT
          <br data-id="element-242" />
          <span className="text-crimson" data-id="element-243">TIERS</span>
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-244">
          {/* MARKET ENTRY */}
          <motion.div className="border-2 border-ivory/20 p-8 md:p-10 flex flex-col" variants={cardVariants} data-id="element-245">
            <span className="font-heading font-bold text-ivory/40 text-sm uppercase tracking-widest" data-id="element-246">
              Tier 01
            </span>
            <h3 className="font-heading font-bold text-ivory uppercase text-2xl md:text-3xl mt-4 tracking-tight" data-id="element-247">
              MARKET ENTRY
            </h3>
            <div className="mt-6 mb-8" data-id="element-248">
              <span className="font-heading font-bold text-ivory text-4xl md:text-5xl" data-id="element-249">
                €4,900
              </span>
              <span className="font-body text-ivory/50 text-lg" data-id="element-250">/month</span>
            </div>
            <ul className="font-body text-ivory/70 space-y-3 flex-1 text-base" data-id="element-251">
              <li className="flex items-start" data-id="element-252">
                <span className="text-crimson mr-3 font-bold" data-id="element-253">—</span>
                Up to 5 jurisdictions
              </li>
              <li className="flex items-start" data-id="element-254">
                <span className="text-crimson mr-3 font-bold" data-id="element-255">—</span>
                10 languages
              </li>
              <li className="flex items-start" data-id="element-256">
                <span className="text-crimson mr-3 font-bold" data-id="element-257">—</span>
                Basic regulatory monitoring
              </li>
              <li className="flex items-start" data-id="element-258">
                <span className="text-crimson mr-3 font-bold" data-id="element-259">—</span>
                Weekly compliance reports
              </li>
              <li className="flex items-start" data-id="element-260">
                <span className="text-crimson mr-3 font-bold" data-id="element-261">—</span>
                Email support
              </li>
            </ul>
            <button className="mt-8 w-full border-2 border-ivory/40 text-ivory font-heading font-bold uppercase tracking-wider py-4 hover:bg-ivory hover:text-midnight transition-colors duration-200 text-sm" data-id="element-262">
              REQUEST ACCESS
            </button>
          </motion.div>

          {/* SCALE — Featured */}
          <motion.div className="border-2 border-saffron bg-saffron/5 p-8 md:p-10 flex flex-col relative" variants={cardVariants} data-id="element-263">
            <div className="absolute top-0 left-0 right-0 h-1 bg-saffron" data-id="element-264" />
            <span className="font-heading font-bold text-saffron text-sm uppercase tracking-widest" data-id="element-265">
              Tier 02 — Recommended
            </span>
            <h3 className="font-heading font-bold text-ivory uppercase text-2xl md:text-3xl mt-4 tracking-tight" data-id="element-266">
              SCALE
            </h3>
            <div className="mt-6 mb-8" data-id="element-267">
              <span className="font-heading font-bold text-ivory text-4xl md:text-5xl" data-id="element-268">
                €12,500
              </span>
              <span className="font-body text-ivory/50 text-lg" data-id="element-269">/month</span>
            </div>
            <ul className="font-body text-ivory/70 space-y-3 flex-1 text-base" data-id="element-270">
              <li className="flex items-start" data-id="element-271">
                <span className="text-saffron mr-3 font-bold" data-id="element-272">—</span>
                Up to 20 jurisdictions
              </li>
              <li className="flex items-start" data-id="element-273">
                <span className="text-saffron mr-3 font-bold" data-id="element-274">—</span>
                25 languages
              </li>
              <li className="flex items-start" data-id="element-275">
                <span className="text-saffron mr-3 font-bold" data-id="element-276">—</span>
                Real-time regulatory intelligence
              </li>
              <li className="flex items-start" data-id="element-277">
                <span className="text-saffron mr-3 font-bold" data-id="element-278">—</span>
                Automated compliance checking
              </li>
              <li className="flex items-start" data-id="element-279">
                <span className="text-saffron mr-3 font-bold" data-id="element-280">—</span>
                Cultural adaptation engine
              </li>
              <li className="flex items-start" data-id="element-281">
                <span className="text-saffron mr-3 font-bold" data-id="element-282">—</span>
                Dedicated compliance manager
              </li>
              <li className="flex items-start" data-id="element-283">
                <span className="text-saffron mr-3 font-bold" data-id="element-284">—</span>
                Priority support
              </li>
            </ul>
            <button className="mt-8 w-full border-2 border-saffron bg-saffron text-midnight font-heading font-bold uppercase tracking-wider py-4 hover:bg-saffron/80 transition-colors duration-200 text-sm" data-id="element-285">
              REQUEST ACCESS
            </button>
          </motion.div>

          {/* ENTERPRISE */}
          <motion.div className="border-2 border-ivory/20 p-8 md:p-10 flex flex-col" variants={cardVariants} data-id="element-286">
            <span className="font-heading font-bold text-ivory/40 text-sm uppercase tracking-widest" data-id="element-287">
              Tier 03
            </span>
            <h3 className="font-heading font-bold text-ivory uppercase text-2xl md:text-3xl mt-4 tracking-tight" data-id="element-288">
              ENTERPRISE
            </h3>
            <div className="mt-6 mb-8" data-id="element-289">
              <span className="font-heading font-bold text-ivory text-4xl md:text-5xl" data-id="element-290">
                Custom
              </span>
            </div>
            <ul className="font-body text-ivory/70 space-y-3 flex-1 text-base" data-id="element-291">
              <li className="flex items-start" data-id="element-292">
                <span className="text-cobalt mr-3 font-bold" data-id="element-293">—</span>
                Unlimited jurisdictions
              </li>
              <li className="flex items-start" data-id="element-294">
                <span className="text-cobalt mr-3 font-bold" data-id="element-295">—</span>
                All supported languages
              </li>
              <li className="flex items-start" data-id="element-296">
                <span className="text-cobalt mr-3 font-bold" data-id="element-297">—</span>
                Full AI engine access
              </li>
              <li className="flex items-start" data-id="element-298">
                <span className="text-cobalt mr-3 font-bold" data-id="element-299">—</span>
                Custom regulatory frameworks
              </li>
              <li className="flex items-start" data-id="element-300">
                <span className="text-cobalt mr-3 font-bold" data-id="element-301">—</span>
                White-label options
              </li>
              <li className="flex items-start" data-id="element-302">
                <span className="text-cobalt mr-3 font-bold" data-id="element-303">—</span>
                24/7 dedicated team
              </li>
              <li className="flex items-start" data-id="element-304">
                <span className="text-cobalt mr-3 font-bold" data-id="element-305">—</span>
                SLA guarantees
              </li>
            </ul>
            <button className="mt-8 w-full border-2 border-ivory/40 text-ivory font-heading font-bold uppercase tracking-wider py-4 hover:bg-ivory hover:text-midnight transition-colors duration-200 text-sm" data-id="element-306">
              REQUEST ACCESS
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}